/**
 * 千分位转换
 * @param number
 */
export function toThousands(number) {
	let num
	if (number === null || number === '') {
		num = number
	} else {
		num = Number(number)
		if (isNaN(num) || num === '' || num === undefined || num === null) {
			return ''
		}
		num = num + ''
		if (/^.*\..*$/.test(num)) {
			let pointIndex = num.lastIndexOf('.')
			let intPart = num.substring(0, pointIndex)
			let pointPart = num.substring(pointIndex + 1, num.length)
			intPart = intPart + ''
			let re = /(-?\d+)(\d{3})/
			while (re.test(intPart)) {
				intPart = intPart.replace(re, '$1,$2')
			}
			num = intPart + '.' + pointPart
		} else {
			num = num + ''
			let re = /(-?\d+)(\d{3})/
			while (re.test(num)) {
				num = num.replace(re, '$1,$2')
			}
		}
	}
	return num
}



// WEBPACK FOOTER //
// ./src/js/utils/filter.js